/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CancelScheduledFundResponse,
  CancelScheduledFund: (params: vp.CancelScheduledFundRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelScheduledFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelScheduledFund, setShouldCancelScheduledFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CancelScheduledFundRequest>({
    ScheduledTransactionID: ''
  });
  const [response, setResponse] = useState<vp.CancelScheduledFundResponse>({
    Success: false,
    ErrorMessage: '',
    Status: ''
  });

  useEffect(() => {
    if (!shouldCancelScheduledFund) return () => {};

    const PostCancelScheduledFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelScheduledFund(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelScheduledFund) void PostCancelScheduledFund();
    setShouldCancelScheduledFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelScheduledFund]);

  return [
    response,
    (_params: vp.CancelScheduledFundRequest) => {
      setParams(_params);
      setShouldCancelScheduledFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Status: '',
      });
      setShouldCancelScheduledFund(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelScheduledFund);